module.exports = __webpack_public_path__ + "static/media/whatsapp.13d0f751.svg";